import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60e5b500"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "correct" }
const _hoisted_2 = {
  class: "swiper-container",
  ref: "Carouseltop"
}
const _hoisted_3 = { class: "swiper-wrapper" }
const _hoisted_4 = { class: "swiper-slide" }
const _hoisted_5 = { class: "boxTail" }
const _hoisted_6 = { class: "swapBox" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "topBox" }, "辅舒良12小时内快速起效，疗效卓越", -1))
const _hoisted_8 = { class: "bakBox" }
const _hoisted_9 = { class: "reportText" }
const _hoisted_10 = {
  class: "boxTail",
  style: {"padding-top":"0.0027rem"}
}
const _hoisted_11 = { class: "leftright" }
const _hoisted_12 = { class: "footBox" }
const _hoisted_13 = { class: "reportBox" }
const _hoisted_14 = { class: "reportText" }
const _hoisted_15 = { class: "boxTail" }
const _hoisted_16 = { class: "leftright" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("div", { class: "yanjiu" }, [
      /*#__PURE__*/_createElementVNode("div", null, [
        /*#__PURE__*/_createTextVNode(" 辅舒良不良反应发生率与安慰剂相似，整体 "),
        /*#__PURE__*/_createElementVNode("p", { class: "blue" }, "耐受性与安全性良好"),
        /*#__PURE__*/_createElementVNode("span", { class: "jiaobiaotwo" }, "2")
      ]),
      /*#__PURE__*/_createElementVNode("div", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "three" })
      ])
    ])
  ])
], -1))
const _hoisted_18 = { class: "footBox" }
const _hoisted_19 = { class: "reportBox" }
const _hoisted_20 = { class: "home" }
const _hoisted_21 = { class: "ip" }
const _hoisted_22 = { class: "pingzi" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "circle" }, [
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div")
], -1))
const _hoisted_24 = { class: "swiper-slide" }
const _hoisted_25 = { class: "boxTail" }
const _hoisted_26 = { class: "swapBox" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "topBox" }, "辅舒良12小时内快速起效，疗效卓越", -1))
const _hoisted_28 = { class: "bakBox" }
const _hoisted_29 = { class: "reportText" }
const _hoisted_30 = {
  class: "boxTail",
  style: {"padding-top":"0.0027rem"}
}
const _hoisted_31 = { class: "leftright" }
const _hoisted_32 = { class: "footBox" }
const _hoisted_33 = { class: "reportBox" }
const _hoisted_34 = { class: "reportText" }
const _hoisted_35 = { class: "boxTail" }
const _hoisted_36 = { class: "leftright" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("div", { class: "yanjiu" }, [
      /*#__PURE__*/_createElementVNode("div", null, [
        /*#__PURE__*/_createTextVNode(" 辅舒良不良反应发生率与安慰剂相似，整体 "),
        /*#__PURE__*/_createElementVNode("p", { class: "blue" }, "耐受性与安全性良好"),
        /*#__PURE__*/_createElementVNode("span", { class: "jiaobiaotwo" }, "2")
      ]),
      /*#__PURE__*/_createElementVNode("div", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "three" })
      ])
    ])
  ])
], -1))
const _hoisted_38 = { class: "footBox" }
const _hoisted_39 = { class: "reportBox" }
const _hoisted_40 = { class: "home" }
const _hoisted_41 = { class: "ip" }
const _hoisted_42 = { class: "pingzi" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "circle2" }, [
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div")
], -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swiper-pagination" }, null, -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "jiexi" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "daan" }),
  /*#__PURE__*/_createElementVNode("div", { class: "dadesc" })
], -1))
const _hoisted_46 = { class: "ip" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "paper" }, [
  /*#__PURE__*/_createElementVNode("span", null, "1. Meltzer EO, Rickard KA, Westlund RE, et al. Onset of therapeutic effect of fluticasone propionate aqueous nasal spray. Annals of Allergy, Asthma & Immunology, 2001, 86(3): 286-291. "),
  /*#__PURE__*/_createElementVNode("span", null, " 2. Kivisaari E, et al. Clin Exp Allergy. 2001, 31(6)855-863.")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_van_image, {
                          class: "rightImg",
                          src: require('../assets/fa2.jpg')
                        }, null, 8, ["src"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_van_image, {
                        width: "7.4rem",
                        height: "2.3rem",
                        src: require('../assets/bingsuan.png')
                      }, null, 8, ["src"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_van_image, {
                          class: "rightImg",
                          width: ".6667rem",
                          height: ".6667rem",
                          src: require('../assets/duigou.png')
                        }, null, 8, ["src"])
                      ]),
                      _hoisted_17
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_van_image, {
                        width: "7.4rem",
                        height: "2.3rem",
                        src: require('../assets/suanfo.png')
                      }, null, 8, ["src"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_van_image, {
                      onClick: $options.nexStep,
                      width: "5.64rem",
                      height: "1.3333rem",
                      src: require('../assets/jxbtn.png')
                    }, null, 8, ["onClick", "src"]),
                    _createVNode(_component_van_image, {
                      class: "finger",
                      width: "1.28rem",
                      height: "1.28rem",
                      src: require('../assets/dong.gif')
                    }, null, 8, ["src"])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_van_image, {
                      class: "finger",
                      width: "2.1467rem",
                      height: "2.6933rem",
                      src: require('../assets/pingzi.png')
                    }, null, 8, ["src"])
                  ])
                ])
              ])
            ]),
            _hoisted_23
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _createVNode(_component_van_image, {
                          class: "rightImg",
                          src: require('../assets/fa1.jpg')
                        }, null, 8, ["src"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      _createVNode(_component_van_image, {
                        width: "7.4rem",
                        height: "2.3rem",
                        src: require('../assets/bingsuan.png')
                      }, null, 8, ["src"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        _createVNode(_component_van_image, {
                          class: "rightImg",
                          width: ".6667rem",
                          height: ".6667rem",
                          src: require('../assets/duigou.png')
                        }, null, 8, ["src"])
                      ]),
                      _hoisted_37
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, [
                      _createVNode(_component_van_image, {
                        width: "7.4rem",
                        height: "2.3rem",
                        src: require('../assets/suanfo.png')
                      }, null, 8, ["src"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, [
                    _createVNode(_component_van_image, {
                      onClick: $options.nexStep,
                      width: "5.64rem",
                      height: "1.3333rem",
                      src: require('../assets/jxbtn.png')
                    }, null, 8, ["onClick", "src"]),
                    _createVNode(_component_van_image, {
                      class: "finger",
                      width: "1.28rem",
                      height: "1.28rem",
                      src: require('../assets/dong.gif')
                    }, null, 8, ["src"])
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    _createVNode(_component_van_image, {
                      class: "finger",
                      width: "2.1467rem",
                      height: "2.6933rem",
                      src: require('../assets/pingzi.png')
                    }, null, 8, ["src"])
                  ])
                ])
              ])
            ]),
            _hoisted_43
          ])
        ]),
        _hoisted_44
      ], 512),
      _hoisted_45
    ]),
    _createElementVNode("div", _hoisted_46, [
      _createVNode(_component_van_image, {
        class: "footBtn",
        onClick: $options.nexStep,
        width: "5.64rem",
        height: "1.3333rem",
        src: require('../assets/jxbtn.png')
      }, null, 8, ["onClick", "src"]),
      _createVNode(_component_van_image, {
        class: "finger",
        width: "1.28rem",
        height: "1.28rem",
        src: require('../assets/dong.gif')
      }, null, 8, ["src"])
    ]),
    _hoisted_47
  ], 64))
}